(function ($, window, undefined) {
    if (window.mg === undefined)
        window.mg = {};

    const _ = window.mg;

    class RegisterRound {
        constructor() {
            this.modal = null;
        }

        go(slot) {
            if (_.user && _.user.HCP == 'N/A') {
                _.ui.confirmmodal({
                    title           : _.translations.ContactYourHomeClub,
                    html            : '<div>' + _.translations.PleaseContactYourHomeClubTheyWillRegisterYourFirstHandicapRound + '</div>',
                    hideAllButtons  : true
                });

                return;
            }

            _.redirect('/Site/HCP/Adjustment' + (slot ? '/?' + $.param(slot) : ''));
        }

        gotoEarlierRounds() {
            _.redirect('/Site/Calendar/?viewEarlierRounds=1');
        }

        open(slot, roundTermTxt, selectRoundTxt) {
            if (false) { // This small block can be used to prevent users from starting a HCP registration. It is hardcoded to false for now.
                mg.showHandicapRegistrationLockedModal(true);
                return;
            }

            const pleaseWait = _.ui.showPleaseWaitModal({ delayed: true });
            const selectedTeeTime = slot ? slot.time : undefined;

            _.ajax.get('/Site/HCP?Handler=UnregisteredRounds' + (selectedTeeTime ? '&selectedTeeTime=' + slot.time : '')).done((data) => {
                pleaseWait.close();

                var hasUncalculatedRound = data && data.HasUncalculatedRound;
                var unregisteredRounds = data ? data.Rounds : null;

                if (hasUncalculatedRound) {
                    this.showRegistrationNotPossible();
                    return;
                }

                if (unregisteredRounds && unregisteredRounds.length > 0) {
                    let showModal = true;

                    if (slot && !slot.slotId && _.cc.textToDateTime(slot.time) <= _.cc.textToDateTime(unregisteredRounds[0].DateTime))
                        showModal = false;

                    if (showModal) {
                        const renderRow = (round, className, primary) => {
                            const dateTime = moment(_.cc.textToDateTime(round.DateTime));

                            return [
                                '<div class="row-wrapper ' + className + '">',
                                    '<div class="row align-items-center flex-nowrap">',
                                        '<div class="col-2 col-lg-3">',
                                            '<div class="row">',
                                                '<div class="col-12 col-lg-6">' + _.cc.formatDate(dateTime) + '</div>',
                                                '<div class="col-12 col-lg-6">' + _.cc.formatTime(dateTime) + '</div>',
                                            '</div>',
                                        '</div>',
                                        '<div class="col">',
                                            '<div class="row text-center">',
                                                '<div class="col-12 col-lg-6">',
                                                    '<div class="club-name">' + round.ClubName + '</div>',
                                                '</div>',
                                                '<div class="col-12 col-lg-6">' + round.CourseName + '</div>',
                                            '</div>',
                                        '</div>',
                                        '<div class="col-auto">',
                                            '<button class="btn btn-' + (primary ? 'primary' : 'blacksqueeze') + ' w-auto" onclick="mg.hcp.registerRound.go({ slotId: ' + (round.SlotID ? '\'' + round.SlotID + '\'' : 'undefined') + ', clubId: \'' + round.ClubID + '\', courseId: \'' + round.CourseID + '\', time: \'' + round.DateTime + '\', selectedTeeTime: ' + (selectedTeeTime ? '\'' + selectedTeeTime + '\'' : 'undefined') + '})">' + _.translations.Register + '</button>',
                                        '</div>',
                                    '</div>',
                                '</div>'
                            ].join('');
                        };

                        const rows = () => {
                            const html    = [];
                            const maxRows = 3;

                            if (slot) {
                                html.push(renderRow({ SlotID: slot.slotId, ClubID: slot.clubId, ClubName: slot.clubName, CourseID: slot.courseId, CourseName: slot.courseName, DateTime: slot.time }, 'border-full'));
                                html.push('<div class="older-rounds-text">' + mg.translations.OlderRounds + '</div>');
                            }

                            for (let i = 0; i < unregisteredRounds.length && i < maxRows; i++) {
                                html.push(renderRow(unregisteredRounds[i], '', i === 0));
                            }

                            return html.join('');
                        };

                        const html = [
                            '<div class="hcp-select-round' + (slot ? ' has-slot' : '') + '">',
                                '<div>',
                                    (selectRoundTxt || '') + ' ' + _.translations.PleaseNoteAllRoundsMustBeEnteredInChronologicalOrder.replace('%rounds%', roundTermTxt.toLowerCase()) + '.',
                                '</div>',

                                '<div class="hcp-select-round-list' + (!slot ? ' space-bottom' : '') + '">',
                                    rows(),
                                '</div>',

                                !slot ? [
                                '<div>',
                                    '<button class="btn btn-blacksqueeze w-100 w-lg-auto mb-3 mb-lg-0 mr-lg-3" onclick="mg.hcp.registerRound.go()">' + _.translations.RegisterNewHCPRound + '</button>',
                                    '<button class="btn btn-blacksqueeze w-100 w-lg-auto" onclick="mg.hcp.registerRound.gotoEarlierRounds()">' + _.translations.SeeEarlierRounds + '</button>',
                                '</div>'].join('') : '',
                            '</div>',
                        ].join('');

                        setTimeout(() => {
                            this.modal = _.ui.actionmodal({
                                title         : _.translations.RegisterHCP,
                                titleInHeader : true,
                                html          : html,
                                hideStateIcon : true,
                                hideFooter    : true,
                                modalBodyFull : true,
                                className     : 'hcp-select-round'
                            });
                        }, 800);

                        return;
                    }
                }
                
                this.go(slot);
            });
        }

        showRegistrationNotPossible(asInfo) {
            var modalType = asInfo ? 'infomodal' : 'errormodal';

            $.isFunction(_.ui[modalType]) && _.ui[modalType]({
                title: _.translations.RegisterHCP,
                html: _.translations.ThereIsARoundThatIsStillBeingCalculatedItMustBeCalculated
            });
        }
    }

    class Scorecard {
        constructor() {

        }

        render(props) {
            var holes = props.holes;
            var scorecardColumns = [];

            var addCol = function (dataProp, title, className, showSums, highlightFunc, highlightCells, titleDesktop) {
                var propsCol = props.columns ? props.columns[dataProp] : null; // Columns are identified by their dataProp value

                if (propsCol && propsCol.showSums === false)
                    showSums = false; // Only set this if it it specifically set to false

                scorecardColumns.push({
                    dataProp: dataProp,
                    title: title,
                    className: className,
                    showSums: showSums,
                    highlightFunc: highlightFunc, // TODO - Remove this when we no longer need it
                    highlightCells: propsCol ? propsCol.highlightCells : highlightCells, // Some columns are always highlighted, and some are only highlighted if the implementation specifies it
                    renderCell: propsCol ? propsCol.renderCell : undefined,
                    hideEmptySum: propsCol ? propsCol.hideEmptySum : undefined,
                    titleDesktop: titleDesktop // In case the column has a different title on desktop
                });
            };

            addCol('Number', mg.translations.Hole, 'hole', false, function (hole) {
                return hole && hole.Strokes;
            }, true);

            addCol('Index', mg.translations.Index, 'index');
            addCol('Par', mg.translations.Par, 'par', true);
            addCol('Strokes', mg.translations.Strokes, 'strokes', true, function () { return true; });

            if (props.columns && props.columns.ExtraStrokes && props.columns.ExtraStrokes.visible) { // Not visible by default
                addCol('ExtraStrokes', mg.translations.PHCP, 'phcp', true);
            }
            
            if (!props.columns || !props.columns.AdjustedGross || props.columns.AdjustedGross.visible !== false) { // Visible by default
                addCol('AdjustedGross', mg.translations.AdjustedGrossShorter, 'adjusted-gross', true, undefined, undefined, mg.translations.AdjustedGrossShort);
            }

            if (!props.columns || !props.columns.Points || props.columns.Points.visible !== false) { // Visible by default
                addCol('Points', mg.translations.Points, 'points', true);
            }

            var scorecardHTML = [];
            var headerCells = [];

            $.each(scorecardColumns, function (k, v) {
                var title = v.title;

                if (v.titleDesktop) {
                    title = [
                        '<div class="d-lg-none">' + v.title + '</div>',
                        '<div class="d-none d-lg-block">' + v.titleDesktop + '</div>'
                    ].join('');
                }

                headerCells.push([
                    '<div class="cell' + (v.className ? ' ' + v.className + '' : '') + '">',
                        '<div class="cell-inner">' + title + '</div>',
                    '</div>',
                ].join(''));
            });

            scorecardHTML.push('<div class="scorecard-header">' + headerCells.join('') + '</div>');

            var scorecardRows = [];
            var totals = {};

            var renderColumn = function (col) {
                var dataProp = col.dataProp;
                var className = col.className;
                var showSums = col.showSums && props.showSums !== false;
                var hideEmptySum = col.hideEmptySum;
                var cells = [];

                var splitCells = mg.hcp.scorecard.shouldSplitCells(holes.length);

                var renderBlock = function (holes, sumIdentifier) {
                    var sum = 0;

                    $.each(holes, function (k, v) {
                        var highlightClass = '';

                        if (col.highlightCells) {
                            highlightClass = 'highlight';

                            if (v.IsPlayed === false) { // Using === false to make sure we don't accidentally hit this block if an implementation doesn't set this property
                                highlightClass += ' not-in-play';
                            } else if (!v.Strokes) {
                                highlightClass += ' faded';
                            }

                            if (props.startHole > 0 && dataProp === 'Number' && v.Number === props.startHole) {
                                highlightClass += ' active-starthole';
                            }
                        }

                        cells.push([
                            '<div class="cell">',
                                '<div class="cell-inner' + (highlightClass ? ' ' + highlightClass : '') + '">',
                                    $.isFunction(col.renderCell) ? col.renderCell(v, dataProp) : (v[dataProp] !== undefined ? v[dataProp] : '&nbsp;'),
                                '</div>',
                            '</div>'
                        ].join(''));

                        sum += v[dataProp] || 0;
                    });

                    if (sumIdentifier) {
                        renderSum(sum, dataProp + '-' + sumIdentifier);
                    }
                };

                var renderSum = function (sum, sumIdentifier, sumClass, forceShow) {
                    cells.push([
                        '<div class="cell sum' + (sumClass ? ' ' + sumClass : '') + '"' + (sumIdentifier ? ' id="sum-' + sumIdentifier + '"' : '') + '>',
                            '<div class="cell-inner">' + (sum === undefined || (sum === 0 && hideEmptySum) || (!showSums && !forceShow) ? '&nbsp;' : sum) + '</div>', // If we have no value to show, or if we shouldn't show sums for this property, we show an empty cell instead
                        '</div>'
                    ].join(''));
                };

                if (splitCells) {
                    var splitIndex = holes.length / 2;
                    var front = holes.slice(0, splitIndex);
                    var back = holes.slice(splitIndex);

                    renderBlock(front, 'front');
                    renderBlock(back, 'back');
                }
                else {
                    renderBlock(holes);
                }

                var totalSum = '';
                var forceShowTotal = false;

                if (showSums) {
                    totalSum = 0;

                    $.each(holes, function (k, v) {
                        totalSum += v[dataProp] || 0;
                    });

                    totals[dataProp] = totalSum;
                }
                else if (dataProp === 'Number') {
                    totalSum = [
                        '<div class="d-none d-lg-block">' + mg.translations.TotalShort + '</div>',
                        '<div class="d-lg-none">' + mg.translations.Total + '</div>'
                    ].join('');
                    
                    forceShowTotal = true; // Show this sum regardless of what the showSums value says
                }

                props.showSums !== false && renderSum(totalSum, dataProp + '-total', 'total2', forceShowTotal);

                scorecardRows.push([
                    '<div class="scorecard-row' + (className ? ' ' + className : '') + '">',
                        cells.join(''),
                    '</div>'
                ].join(''));
            };

            $.each(scorecardColumns, function (k, v) {
                renderColumn(v);
            });

            scorecardHTML.push('<div class="scorecard-rows fixed-cell-width-dt">' + scorecardRows.join('') + '</div>');

            var scorecardTotals = props.showTotalsRow === false ? '' : this.renderTotalsRow({
                playedHoles: props.playedHoles,
                totals: totals,
                allowAdjustedPointsText: props.allowAdjustedPointsText,
                showAddedHolesText: props.playedHoles < props.holes.length
            });

            props.$target.append([
                '<div class="scorecard-wrapper' + (props.columns.ExtraStrokes && props.columns.ExtraStrokes.visible ? ' show-phcp-column' : '') + '"' + (props.renderAsHidden ? ' style="display: none;"' : '') + '>',
                    '<div class="scorecard">',
                        scorecardHTML.join(''),
                    '</div>',
                    scorecardTotals,
                '</div>'
            ].join(''));
        }

        renderTotalsRow(props) {
            var scorecardTotals = [];

            var renderTotal = function (title, value, className) {
                return [
                    '<div class="scorecard-total' + (className ? ' ' + className : '') + '">',
                    '<span>' + title + '</span>',
                    value !== undefined ? ('<span>' + value + '</span>') : '',
                    '</div>'
                ].join('');
            };

            var showPlayedHolesRow = false;
            var resultTitle = mg.translations.Result;
            var resultValue = props.playedHoles + ' hål';
            var expectedHoles = props.expectedHoles || 18; // This may change one day, but for now a scorecard is always 18 holes (lower than that is adjusted to 18)
            var calculateAdjustedPoints = false;
            var allowAdjustedPointsText = false;

            if (props.playedHoles < expectedHoles) {
                scorecardTotals.push([
                    '<div class="scorecard-total-row">',
                        renderTotal(mg.translations.PlayedHoles, props.playedHoles + ' hål', 'played-holes'),
                    '</div>'
                ].join(''));

                showPlayedHolesRow = true;
                resultTitle = '<span>' + mg.translations.ResultXHoles.replace('%num%', 18) + '</span><span class="d-none d-lg-inline">&nbsp;(' + mg.translations.Enumerated.toLowerCase() + ')</span>'; // The (uppräknat) part is only shown in desktop, as there is no room for it in mobile
                resultValue = '';
                calculateAdjustedPoints = props.allowCalculateAdjustedPoints;
                allowAdjustedPointsText = props.allowAdjustedPointsText;
            }
            else if (props.titleOverride) {
                resultTitle = props.titleOverride;
                resultValue = undefined;
            }

            var scorecardTotalRow = [];

            if (!props.minHoles || props.playedHoles >= props.minHoles) {
                scorecardTotalRow.push(renderTotal(resultTitle, resultValue, 'result'));
                props.showAdjustedGross !== false && scorecardTotalRow.push(renderTotal(mg.translations.AdjustedGrossShort, props.totals['AdjustedGross'], 'adjusted-gross')); // TODO - Maybe just use the pre-calculated value from item

                var points = props.totals['Points'];
                var pointsTitle = mg.translations.Points;

                if (calculateAdjustedPoints) {
                    points += this.calculatePointsForNonPlayedHoles({ playedHoles: props.playedHoles, expectedHoles: expectedHoles }); // Add points for non-played holes, if any
                }

                if (calculateAdjustedPoints || allowAdjustedPointsText) {
                    pointsTitle = mg.translations.AdjustedPointsShort;
                }

                points !== undefined && scorecardTotalRow.push(renderTotal(pointsTitle, points, 'points')); // TODO - Maybe just use the pre-calculated value from item
            }

            scorecardTotalRow.length && scorecardTotals.push('<div class="scorecard-total-row">' + scorecardTotalRow.join('') + '</div>');

            var scorecardAddedHolesText = props.showAddedHolesText ? '<div class="scorecard-added-holes-text">' + mg.translations.theResultToGenerateTheHandicapHasBeenAdded + '</div>' : '';

            return [
                '<div class="scorecard-totals-wrapper' + (props.className ? ' ' + props.className : '') + '">',
                    '<div class="scorecard-totals' + (showPlayedHolesRow ? ' show-played-holes-row' : '') + '">' + scorecardTotals.join('') + '</div>',
                    scorecardAddedHolesText || '',
                '</div>'
            ].join('');
        }

        calculatePointsForNonPlayedHoles(props) {
            var expectedHoles = props.expectedHoles || 18; // This may change one day, but for now a scorecard is always 18 holes (lower than that is adjusted to 18)
            var missingHoles = expectedHoles - props.playedHoles;
            return missingHoles > 0 ? (missingHoles * 2) - (props.playedHoles >= 14 ? 0 : 1) : 0; // The formula: 9-13 holes = 2+1, 14-17 holes = 2+2. Assume it means you get a par for each missing hole, except the last one, unless you have played between 14 and 17 holes, in which case you also get a par for the last hole
        }

        shouldSplitCells(holeCount) {
            return holeCount > 9 && holeCount % 2 === 0;
        }
    }

    _.hcp = {
        registerRound: new RegisterRound(),
        scorecard: new Scorecard()
    };
})(jQuery, window);
